/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Shot_ScrollInputs */

const en_mk_shot_scroll = /** @type {(inputs: Mk_Shot_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product screenshot. Scroll to explore the details; press Escape or Close to return.`)
};

const id_mk_shot_scroll = /** @type {(inputs: Mk_Shot_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Screenshot produk. Geser untuk melihat detail; tekan Escape atau Tutup untuk kembali.`)
};

/**
* | output |
* | --- |
* | "Product screenshot. Scroll to explore the details; press Escape or Close to return." |
*
* @param {Mk_Shot_ScrollInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_shot_scroll = /** @type {((inputs?: Mk_Shot_ScrollInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Shot_ScrollInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_shot_scroll(inputs)
	return en_mk_shot_scroll(inputs)
});